import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  STORE_NOTIFICATION_FETCH_ALERT,
  STORE_STATUS_INITIALIZED,
  STORE_NOTIFICATION,
} from 'constants/store'
import { Alert, ErrorStore } from '@types'
import {
  createGenericSlice,
  GenericState,
  createReducers,
  ExtraReducers,
} from 'stores/generics'
import { Payload } from 'stores'

export type AlertState = Alert

type State = GenericState<AlertState>

export const initialState: State = {
  data: {
    description: '',
    title: '',
    type: 'default',
    autoHideDuration: 5000,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'center',
    },
  },
  status: STORE_STATUS_INITIALIZED,
  error: null,
}

export const fetchAlert = createAsyncThunk<AlertState, Promise<Alert>, Payload>(
  STORE_NOTIFICATION_FETCH_ALERT,
  async (promise: Promise<Alert>, { rejectWithValue }) => {
    try {
      const response = await promise
      return response
    } catch (e: unknown) {
      const { code, message } = e as ErrorStore
      return rejectWithValue({ code, message })
    }
  }
)

const extraReducers: ExtraReducers = createReducers<AlertState, Alert, Payload>(
  fetchAlert,
  initialState.data
)

const userSlice = createGenericSlice({
  name: STORE_NOTIFICATION,
  initialState,
  reducers: {},
  extraReducers,
})

const { actions, reducer } = userSlice

const { clear } = actions

export { clear }

export default reducer
